import "./FloatingMenu.css"
import { useLocation } from 'react-router-dom';

function FloatingMenu () {

    const {pathname} = useLocation();

    if(!pathname.startsWith('/mypage')){
    return(
        <>
            <ul className="floatingMenu">
                <li>
                    <a href="https://law.jobofbrothers.com/" target="_blank" rel="noreferrer">
                        <img src={`${process.env.PUBLIC_URL}/images/law-icon.png`} alt="잡오브라더스 법무법인·변호사 홈페이지 제작"/>
                    </a>
                </li>
                <li>
                    <a href="https://www.instagram.com/jobofbrother_com/" target="_blank" rel="noreferrer">
                        <img src={`${process.env.PUBLIC_URL}/images/floating_instagram.svg`} alt="instagram"/>
                    </a>
                </li>
                <li>
                    <a href="https://blog.naver.com/jobofbrothers" target="_blank" rel="noreferrer">
                        <img src={`${process.env.PUBLIC_URL}/images/floating_blog.svg`} alt="instagram"/>
                    </a>
                </li>
            </ul>
        </>
    )
    }
}

export default FloatingMenu; 